import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import BasicTemplate from './BasicTemplate.js';

function Disapproved(props) {
	return (<BasicTemplate>
				<FormattedHTMLMessage id="app.disapproved" description=" "/>
			</BasicTemplate>);
}

export default Disapproved;


/** WEBPACK FOOTER **
 ** ./src/components/Disapproved.js
 **/